import React from "react";
import OptimizedImg from "../../../../components/OptimizedImg";
import "video-react/dist/video-react.css";
import { Player, BigPlayButton } from "video-react";

function PostContent({ className = "-card-content", postImages }) {
  return (
    <article className={className}>
      {postImages.map((image, index) => (
        <figure className="-image-figure" key={index}>
          {image.type === "video" ? (
            <Player src={image.src} preload="metadata">
              <BigPlayButton position="center" />
            </Player>
          ) : (
            <OptimizedImg url={image.src} size="l" alt="" className="-single-img" />
          )}
          {image.caption && image.caption.length > 0 ? (
            <figcaption className="-image-caption">{image.caption}</figcaption>
          ) : (
            ""
          )}
        </figure>
      ))}
    </article>
  );
}

export default PostContent;



// WEBPACK FOOTER //
// ./src/components/Post/Components/PostImages/index.js